import { useContext } from "react"
import { SurveyContext } from "../Main/SurveyContext"
import { NumberWithWords } from "~/const/globalStrings"
import { SurveyOverviewTexts } from "~/types/dataTypes"

const SurveyIntroText = ({ texts }: { texts: SurveyOverviewTexts }) => {
  const context = useContext(SurveyContext)
  if (!context) return <></>

  const surveyCompletion = Object.values(context?.status)

  const incompleteSurveys =
    surveyCompletion.length - surveyCompletion.filter(Boolean).length

  const allSurveysComplete = surveyCompletion.every(Boolean)
  const noSurveysComplete = surveyCompletion.filter(Boolean).length === 0

  const halfOfSurveysComplete =
    surveyCompletion.filter(Boolean).length ===
    Math.floor(surveyCompletion.length / 2)

  const atLeastOneSurveyComplete = surveyCompletion.filter(Boolean).length >= 1

  const renderText = () => {
    if (allSurveysComplete) {
      return (
        <p className="font-bold text-primary-900">{texts.allSurveysComplete}</p>
      )
    } else if (noSurveysComplete) {
      return (
        <>
          {surveyCompletion.length === 1 ? (
            <p className="font-bold text-primary-900">
              Besvar venligst dette spørgeskema.
            </p>
          ) : (
            <p className="font-bold text-primary-900">
              Besvar venligst disse {NumberWithWords[surveyCompletion.length]}{" "}
              spørgeskemaer.
            </p>
          )}
        </>
      )
    } else if (halfOfSurveysComplete) {
      return (
        <p className="font-bold text-primary-900">Du er nu halvvejs igennem.</p>
      )
    } else if (atLeastOneSurveyComplete) {
      return (
        <p className="font-bold text-primary-900">
          Tak. Du mangler nu {NumberWithWords[incompleteSurveys]} spørgeskemaer.
        </p>
      )
    } else {
      return (
        <p className="font-bold text-primary-900">
          Nu vil vi bede dig besvare disse spørgeskemaer.
        </p>
      )
    }
  }

  return (
    <div className="text-3xl text-neutral-900 font-serif">{renderText()}</div>
  )
}

export default SurveyIntroText
